module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<!--  css in staticUCs.css  -->\n<fieldset class="vueannuelle-calendrier" style="overflow:hidden">\n  <div class="phx-formTable">\n    <div class="tableCalendrier"></div>\n  </div>\n</fieldset>';
}
return __p;
};
